import { createSlice } from '@reduxjs/toolkit';

export const slice = createSlice({
    name: 'userData',
    initialState: {
        user: null,
        sessionTimeout: null
    },
    reducers: {
        saveUserData: (state, action) => {
            state.user = action.payload.user;
            state.sessionTimeout = action.payload.sessionTimeout;
        }
    }
});

export const { saveUserData } = slice.actions;

export default slice.reducer;
